import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatesSeparatorComponent } from './states-separator.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RsAvatarModule } from '@app/dashboard/rs-avatar/rs-avatar.module';

@NgModule({
    declarations: [StatesSeparatorComponent],
    exports: [StatesSeparatorComponent],
    imports: [CommonModule, MatDividerModule, MatTooltipModule, RsAvatarModule]
})
export class StatesSeparatorModule {}
